import {
    CompetitionDateCreateApiInterface,
    CompetitionDateEditApiInterface,
    CompetitionDispatchApiInterface,
    CompetitionGenerateDatesApiInterface,
    CompetitionGenerateMatchesApiInterface,
    CompetitionGlobalChangeRequestDataApiInterface,
    CompetitionRequestApiInterface,
    CompetitionSignUpClubApiInterface,
    SeasonApiEnum,
    CompetitionUpdateApiInterface,
    CompetitionTeamEditApiInterface,
    CompetitionCopyTeamsFromCompetitionApiInterface,
    CompetitionCopyTeamTournamentApiInterface,
    CompetitionTeamAssociateApiInterface,
    CompetitionCreateTeamListPlayer,
    CompetitionTeamConfirmListApiInterface,
    CompetitionDeleteTeamListPlayer,
    CompetitionCopyDatesApiInterface,
} from 'submodules/api_middleware';
import { QueryRequestInterface } from 'submodules/api_middleware/src/interfaces/InternalInterfaces';
import { ApiResponseInterface } from 'utils/helpers/browser/getResponse';
import fetcher, {
    fetcherFull,
    MethodEnum,
} from 'utils/helpers/browser/newFetcher';

export const getCompetitionList = async (
    query: QueryRequestInterface
): Promise<any> => {
    return await fetcher(`/api/competition/list`, MethodEnum.GET, query);
};

export const createCompetition = async (
    data: CompetitionDispatchApiInterface
): Promise<any> => {
    return await fetcher(
        `/api/competition/create`,
        MethodEnum.POST,
        undefined,
        { data }
    );
};

export const edit = async (
    competitionId: number,
    data: CompetitionUpdateApiInterface
): Promise<ApiResponseInterface> => {
    return await fetcher<ApiResponseInterface>(
        `/api/competition/${competitionId}/edit`,
        MethodEnum.PUT,
        null,
        { competitionId, data }
    );
};

export const deleteCompetition = async (
    competitionId: number
): Promise<ApiResponseInterface> => {
    return await fetcher<ApiResponseInterface>(
        `/api/competition/delete`,
        MethodEnum.DELETE,
        null,
        { competitionId }
    );
};

export const check = async (
    competitionId: number
): Promise<ApiResponseInterface> => {
    return await fetcher<ApiResponseInterface>(
        `/api/competition/${competitionId}/check`,
        MethodEnum.GET
    );
};

export const signUpClub = async (
    competitionId: number,
    data: CompetitionSignUpClubApiInterface
): Promise<ApiResponseInterface> => {
    return await fetcher<ApiResponseInterface>(
        `/api/competition/${competitionId}/signup_club`,
        MethodEnum.POST,
        null,
        { competitionId, data }
    );
};

export const getCompetitionTeamList = async (
    query: QueryRequestInterface
): Promise<any> => {
    return await fetcherFull(
        `/api/competition/teamList`,
        MethodEnum.GET,
        query
    );
};

export const createTeams = async (
    competitionId: number,
    data: number[]
): Promise<ApiResponseInterface> => {
    return await fetcher<ApiResponseInterface>(
        `/api/competition/${competitionId}/teams/create`,
        MethodEnum.POST,
        null,
        { competitionId, data }
    );
};

export const copyTeamsFromCompetition = async (
    competitionId: number,
    data: CompetitionCopyTeamsFromCompetitionApiInterface
): Promise<ApiResponseInterface> => {
    return await fetcher<ApiResponseInterface>(
        `/api/competition/${competitionId}/teams/copyFromCompetition`,
        MethodEnum.POST,
        null,
        { competitionId, data }
    );
};

export const copyTeamTournament = async (
    competitionId: number,
    data: CompetitionCopyTeamTournamentApiInterface
): Promise<ApiResponseInterface> => {
    return await fetcher<ApiResponseInterface>(
        `/api/competition/${competitionId}/teams/copyTournament`,
        MethodEnum.POST,
        null,
        { competitionId, data }
    );
};

export const approveTeam = async (
    competitionId: number,
    teamId: number
): Promise<ApiResponseInterface> => {
    return await fetcher<ApiResponseInterface>(
        `/api/competition/${competitionId}/teams/approve`,
        MethodEnum.POST,
        null,
        { competitionId, teamId }
    );
};

export const rejectTeam = async (
    competitionId: number,
    teamId: number
): Promise<ApiResponseInterface> => {
    return await fetcher<ApiResponseInterface>(
        `/api/competition/${competitionId}/teams/reject`,
        MethodEnum.POST,
        null,
        { competitionId, teamId }
    );
};

export const deleteTeam = async (
    competitionId: number,
    teamId: number
): Promise<ApiResponseInterface> => {
    return await fetcher<ApiResponseInterface>(
        `/api/competition/${competitionId}/teams/delete`,
        MethodEnum.DELETE,
        null,
        { competitionId, teamId }
    );
};

export const updateTeam = async (
    competitionId: number,
    teamId: number,
    data: CompetitionTeamEditApiInterface
): Promise<ApiResponseInterface> => {
    return await fetcher<ApiResponseInterface>(
        `/api/competition/${competitionId}/teams/edit`,
        MethodEnum.PUT,
        null,
        { competitionId, teamId, data }
    );
};

export const associateClubToTeam = async (
    competitionId: number,
    teamId: number,
    data: CompetitionTeamAssociateApiInterface
): Promise<ApiResponseInterface> => {
    return await fetcher<ApiResponseInterface>(
        `/api/competition/${competitionId}/teams/assocaiteClub`,
        MethodEnum.PUT,
        null,
        { competitionId, teamId, data }
    );
};

export const createCompetitionStartFeeTransaction = async (
    competitionId: number,
    teamId: number
): Promise<ApiResponseInterface> => {
    return await fetcher<ApiResponseInterface>(
        `/api/competition/${competitionId}/teams/startingFee`,
        MethodEnum.POST,
        null,
        { teamId, competitionId }
    );
};

export const createCompetitionStartFeeBulkTransaction = async (
    competitionId: number
): Promise<ApiResponseInterface> => {
    return await fetcher<ApiResponseInterface>(
        `/api/competition/${competitionId}/teams/bulkStartingFee`,
        MethodEnum.POST,
        null,
        { competitionId }
    );
};

export const deleteDate = async (
    competitionId: number,
    dateNumber: number
): Promise<ApiResponseInterface> => {
    return await fetcher<ApiResponseInterface>(
        `/api/competition/${competitionId}/dates/delete`,
        MethodEnum.DELETE,
        null,
        { competitionId, dateNumber }
    );
};

export const createDates = async (
    competitionId: number,
    data: CompetitionDateCreateApiInterface,
    query?: QueryRequestInterface
): Promise<ApiResponseInterface> => {
    return await fetcher<ApiResponseInterface>(
        `/api/competition/${competitionId}/dates/create`,
        MethodEnum.POST,
        query,
        { competitionId, data }
    );
};

export const copyDates = async (
    competitionId: number,
    data: CompetitionCopyDatesApiInterface
): Promise<ApiResponseInterface> => {
    return await fetcher<ApiResponseInterface>(
        `/api/competition/${competitionId}/dates/copy`,
        MethodEnum.POST,
        null,
        { data }
    );
};

export const clearBerger = async (
    competitionId: number,
    season: SeasonApiEnum
): Promise<ApiResponseInterface> => {
    return await fetcher<ApiResponseInterface>(
        `/api/competition/${competitionId}/dates/berger_unset`,
        MethodEnum.POST,
        null,
        { competitionId, data: { season } }
    );
};

export const createBerger = async (
    competitionId: number,
    season: SeasonApiEnum
): Promise<ApiResponseInterface> => {
    return await fetcher<ApiResponseInterface>(
        `/api/competition/${competitionId}/dates/berger_set`,
        MethodEnum.POST,
        null,
        { competitionId, data: { season } }
    );
};

export const editDate = async (
    competitionId: number,
    dateNumber: number,
    data: CompetitionDateEditApiInterface
): Promise<ApiResponseInterface> => {
    return await fetcher<ApiResponseInterface>(
        `/api/competition/${competitionId}/dates/edit`,
        MethodEnum.PUT,
        null,
        { competitionId, dateNumber, data }
    );
};

export const generateDates = async (
    competitionId: number,
    data: CompetitionGenerateDatesApiInterface
): Promise<ApiResponseInterface> => {
    return await fetcher<ApiResponseInterface>(
        `/api/competition/${competitionId}/dates/generate`,
        MethodEnum.POST,
        null,
        { competitionId, data }
    );
};

export const generateMatchesPreview = async (
    competitionId: number,
    data: CompetitionGenerateMatchesApiInterface
): Promise<ApiResponseInterface> => {
    return await fetcher<ApiResponseInterface>(
        `/api/competition/${competitionId}/matches/generate_preview`,
        MethodEnum.POST,
        null,
        { competitionId, data }
    );
};

export const generateMatches = async (
    competitionId: number,
    data: CompetitionGenerateMatchesApiInterface
): Promise<ApiResponseInterface> => {
    return await fetcher<ApiResponseInterface>(
        `/api/competition/${competitionId}/matches/generate_matches`,
        MethodEnum.POST,
        null,
        { competitionId, data }
    );
};

export const createGlobalChangeRequest = async (
    competitionId: number,
    data: CompetitionRequestApiInterface
): Promise<ApiResponseInterface> => {
    return await fetcher<ApiResponseInterface>(
        `/api/competition/${competitionId}/global_change_requests/create`,
        MethodEnum.POST,
        null,
        { competitionId, data }
    );
};

export const editGlobalRequest = async (
    competitionId: number,
    globalRequestId: number,
    data: CompetitionGlobalChangeRequestDataApiInterface
): Promise<ApiResponseInterface> => {
    return await fetcher<ApiResponseInterface>(
        `/api/competition/${competitionId}/global_change_requests/edit`,
        MethodEnum.PUT,
        null,
        { competitionId, globalRequestId, data }
    );
};

export const deleteGlobalRequest = async (
    competitionId: number,
    globalRequestId: number
): Promise<ApiResponseInterface> => {
    return await fetcher<ApiResponseInterface>(
        `/api/competition/${competitionId}/global_change_requests/delete`,
        MethodEnum.DELETE,
        null,
        { competitionId, globalRequestId }
    );
};

export const statsTeams = async (
    competitionId: number,
    query: QueryRequestInterface
): Promise<any> => {
    return await fetcher(
        `/api/competition/${competitionId}/stats/teams`,
        MethodEnum.GET,
        { ...query, competitionId }
    );
};

export const getCopmetitionDatesList = async (
    competitionId: number
): Promise<any> => {
    return await fetcher(
        `/api/competition/${competitionId}/dateList`,
        MethodEnum.GET,
        { id: competitionId }
    );
};

export const createCompetitionTeamPlayer = async (
    competitionId: number,
    teamId: number,
    data: CompetitionCreateTeamListPlayer
): Promise<any> => {
    return await fetcher(
        `/api/competition/${competitionId}/teams/${teamId}/create_list_player`,
        MethodEnum.POST,
        undefined,
        { data }
    );
};

export const deleteCompetitionTeamPlayer = async (
    competitionId: number,
    teamId: number,
    data: CompetitionDeleteTeamListPlayer
): Promise<any> => {
    return await fetcher(
        `/api/competition/${competitionId}/teams/${teamId}/delete_list_player`,
        MethodEnum.DELETE,
        undefined,
        { data }
    );
};

export const confirmCompetitionTeamPlayerList = async (
    competitionId: number,
    teamId: number,
    data: CompetitionTeamConfirmListApiInterface
): Promise<ApiResponseInterface> => {
    return await fetcher<ApiResponseInterface>(
        `/api/competition/${competitionId}/teams/${teamId}/confirm_list_player`,
        MethodEnum.PUT,
        null,
        { data }
    );
};
